import { DashboardItemDescriptor } from '@unistocks/features/dashboard/dashboard-item-descriptor';
import { dashboardItemDescriptor as assetListDescriptor } from '@unistocks/features/dashboard/components/dashboard-data/asset-list/widget';
import { dashboardItemDescriptor as calendarDescriptor } from '@unistocks/features/dashboard/components/dashboard-data/date/widget';
import { dashboardItemDescriptor as eventViewDescriptor } from '@unistocks/features/dashboard/components/dashboard-data/event-view/widget';
import { dashboardItemDescriptor as netSavingsDescriptor } from '@unistocks/features/dashboard/components/dashboard-data/net-savings/widget';
import { dashboardItemDescriptor as portfolioHistoryDescriptor } from '@unistocks/features/dashboard/components/dashboard-data/portfolio-history/widget';
import { dashboardItemDescriptor as portfolioOverviewDescriptor } from '@unistocks/features/dashboard/components/dashboard-data/portfolio-overview/widget';
import { dashboardItemDescriptor as savingsGoalDescriptor } from '@unistocks/features/dashboard/components/dashboard-data/savings-goal/widget';
import { DashboardItemType } from '@unistocks/proxy/axios-client';

export const dashboardItemDescriptors: Record<DashboardItemType, DashboardItemDescriptor> = {
  [DashboardItemType.Date]: calendarDescriptor,
  [DashboardItemType.PortfolioOverview]: portfolioOverviewDescriptor,
  [DashboardItemType.PortfolioHistory]: portfolioHistoryDescriptor,
  [DashboardItemType.SavingsGoal]: savingsGoalDescriptor,
  [DashboardItemType.AssetList]: assetListDescriptor,
  [DashboardItemType.EventView]: eventViewDescriptor,
  [DashboardItemType.NetSavings]: netSavingsDescriptor
};

export const getDashboardItemDescriptor = (type: DashboardItemType): DashboardItemDescriptor => {
  const descriptor = dashboardItemDescriptors[type];

  if (!descriptor) {
    throw new Error(`Unknown dashboard item type: ${type}`);
  }

  return descriptor;
};

export const hasMultipleLayouts = (type: DashboardItemType) =>
  getDashboardItemDescriptor(type).settingsSteps.length > 1;
